import { useState } from 'react';

export interface MockTestConfig {
  subjects: string[];
  chapters: Record<string, string[]>;
  formats: string[]; // e.g. ['mcq', 'cq', 'both']
  totals: Record<string, number>; // question counts per subject
  negativeMarking: boolean;
  duration: number;
}

export const useMockTest = () => {
  const [step, setStep] = useState<number>(1);
  const [config, setConfig] = useState<MockTestConfig>({
    subjects: [],
    chapters: {},
    formats: ['mcq'],
    totals: {},
    negativeMarking: false,
    duration: 20,
  });

  const next = () => setStep((s) => Math.min(s + 1, 4));
  const back = () => setStep((s) => Math.max(s - 1, 1));

  return {
    step,
    setStep,
    config,
    setConfig,
    next,
    back,
  };
};
